// Only scalar, single-value changes can be overridden. Structured strategy,
// targeting, creative and multi-edit recommendations retain their reviewed payload.
const ACTIONS = new Set(['budget', 'daily_budget', 'impression_cap', 'impression_caps',
  'impressions', 'target_cpa', 'target_roas', 'bid']);
const FIELDS = new Set(['dailyCap', 'ioDailyCap', 'imps', 'cpm', 'bidFloor']);
const numeric = (value) => (typeof value === 'number' || typeof value === 'string')
  && String(value).trim() !== '' && Number.isFinite(Number(value));

export function editableRecommendation(card) {
  const raw = card.raw;
  if (!card.auto || !raw || raw.suggested_values) return null;
  const edits = raw.dv360_edit_operation?.edits;
  if (edits) {
    if (edits.length !== 1 || edits[0].operation !== 'set_field'
      || !FIELDS.has(edits[0].field) || !numeric(edits[0].value)) return null;
    return { value: String(edits[0].value), integer: edits[0].field === 'imps' };
  }
  if (!(raw.target_id && raw.target_type) && !(raw.entity_type && raw.entity_name)) return null;
  if (!ACTIONS.has(raw.action_type) || !numeric(raw.recommended_value)) return null;
  const op = raw.sem_edit_operation;
  if (op && (!['budget', 'target_cpa', 'target_roas', 'bid'].includes(op.operation)
    || !Array.isArray(op.campaigns) || op.campaigns.length !== 1)) return null;
  return { value: String(raw.recommended_value), integer: /impression/.test(raw.action_type) };
}

export function overrideRecommendation(card, value) {
  const spec = editableRecommendation(card);
  const amount = Number(value);
  if (!spec || !numeric(value) || amount <= 0 || (spec.integer && !Number.isInteger(amount))) {
    return null;
  }
  const raw = { ...card.raw, recommended_value: amount };
  // Descriptions can contain the old amount; rebuild them from the new scalar.
  delete raw.description;
  if (!raw.target_id || !raw.target_type) {
    if (!raw.dv360_edit_operation && !(raw.entity_type && raw.entity_name)) return null;
  }
  if (raw.dv360_edit_operation) {
    raw.dv360_edit_operation = { ...raw.dv360_edit_operation,
      edits: raw.dv360_edit_operation.edits.map((edit) => ({ ...edit, value: String(amount),
        ...(edit.new_value !== undefined ? { new_value: String(amount) } : {}) })) };
  }
  if (raw.sem_edit_operation) {
    const op = raw.sem_edit_operation;
    const field = { budget: 'daily_budget', target_cpa: 'target_cpa', target_roas: 'target_roas', bid: 'cpc_bid' }[op.operation];
    raw.sem_edit_operation = { ...op, campaigns: op.campaigns.map((campaign) => ({ ...campaign, [field]: amount })) };
  }
  return { ...card, rec: String(amount), raw };
}
